<template>
  <v-dialog v-model="dialog" persistent="persistent">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t('pageHeader.last20Transaction') }}</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="icon" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line
          hide-details clearable ></v-text-field>
        <v-data-table :headers="headers" :items="transaction" :loading="loading" :search="search"
          :pagination.sync="pagination"><template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ props.item.InvoiceID }}</td>
              <td class="text-xs-left">{{ $moment(props.item.date).format('MM/DD/YYYY') }}</td>
              <td class="text-xs-left">{{ props.item.AccountName }} </td>
              <td class="text-xs-right">{{ props.item.SubTotal | currency }} </td>
              <td class="text-xs-right">{{ props.item.TaxAmount | currency }} </td>
              <td class="text-xs-right">{{ props.item.GrandTotal | currency }} </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import locationService from '../service.js';

export default {
  name: 'last-20-transaction',
  props: ['transactionDialog', 'storeID'],
  data() {
    return {
      transaction: [],
      dialog: false,
      headers: [
        {
          text: this.$t("labels.invoiceID"),
          align: "left",
          sortable: true,
          value: "InvoiceID"
        },
        {
          text: this.$t("labels.date"),
          value: "InvoiceDate",
          sortable: true
        },
        {
          text: this.$t("labels.customerName"),
          value: "AccountName",
          sortable: true
        },
        {
          text: this.$t("labels.subTotal"),
          value: "SubTotal",
          sortable: true
        },
        {
          text: this.$t("labels.taxAmount"),
          value: "TaxAmount",
          sortable: true
        },
        {
          text: this.$t('labels.grandTotal'),
          value: 'GrandTotal',
          sortable: true,
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'InvoiceDate',
        descending: true,
      }
    };
  },
  watch: {
    transactionDialog(val) {
      this.dialog = val
      this.getList()
    }
  },
  methods: {
    getList() {
      this.loading = true
      locationService.getLastInvoice(this.storeID)
        .then((response) => {
          this.transaction = response.data
          this.loading = false;
        })
    },
  }
};
</script>
